<!-- @format -->
@let productIdentifier = productIdentifier$ | async;
@if (productIdentifier) {
	@if (type === 'link') {
		<button
			hmf-action-text
			class="review-button"
			variant="secondary"
			(click)="triggerWriteAReview(productIdentifier)"
		>
			{{ label }}
		</button>
	} @else {
		<button
			hmf-button
			[class.review-button-drawer]="isDrawer"
			[variant]="'secondary'"
			[label]="label"
			(click)="triggerWriteAReview(productIdentifier)"
		>
			{{ label }}
		</button>
	}
}
